<template>

</template>

<script>
export default {
    name: "Success",
    methods: {
    },
    mounted() {
        this.$store.commit('changePageData', {
                title: 'Account created',
                desc: 'Tap anywhere to continue',
                splashUrl: this.$router.resolve({name: 'staff.home'}).href
            }
        );
    }
}
</script>